"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupWrapper = void 0;
var tslib_1 = require("tslib");
var types_1 = require("../../types");
var stringUtils_1 = require("../../utils/stringUtils");
var Member_1 = require("../Member/Member");
var WixStatics_1 = require("../../services/wixStatics/WixStatics");
var ImageSDK_1 = require("../ImageSDK/ImageSDK");
var GroupAccessRestriction_1 = require("./GroupAccessRestriction");
var MemberRole_1 = require("../Member/MemberRole");
var GroupWrapper = /** @class */ (function () {
    function GroupWrapper(group) {
        this.updatePaths = new Set();
        this.setGroup(group);
    }
    GroupWrapper.createEmpty = function () {
        return {
            relationship: types_1.ApiTypes.v1.RelationshipWithGroup.NONE,
            roles: [],
            details: {},
            clientData: {
                isAddMembersBannerClosed: 'true',
            },
            settings: {
                privacyLevel: types_1.ApiTypes.v1.GroupPrivacyLevel.PUBLIC,
            },
            memberCount: 0,
        };
    };
    GroupWrapper.prototype.getId = function () {
        return this.group.groupId;
    };
    GroupWrapper.prototype.getDescription = function () {
        try {
            return this.group.details.description || '';
        }
        catch (e) {
            return '';
        }
    };
    GroupWrapper.prototype.getCreatedDate = function () {
        return this.group.createdAt;
    };
    GroupWrapper.prototype.getUpdatePaths = function () {
        return Array.from(this.updatePaths).map(stringUtils_1.toSnakeCase);
    };
    GroupWrapper.prototype.getTitle = function () {
        try {
            return this.group.details.title;
        }
        catch (e) {
            return;
        }
    };
    GroupWrapper.prototype.getSlug = function () {
        return this.group.slug;
    };
    GroupWrapper.prototype.getPrivacy = function () {
        try {
            return this.group.settings.privacyLevel;
        }
        catch (e) {
            return;
        }
    };
    GroupWrapper.prototype.isSecret = function () {
        return this.getPrivacy() === types_1.ApiTypes.v1.GroupPrivacyLevel.SECRET;
    };
    GroupWrapper.prototype.isPublic = function () {
        return this.getPrivacy() === types_1.ApiTypes.v1.GroupPrivacyLevel.PUBLIC;
    };
    GroupWrapper.prototype.isPrivate = function () {
        return this.getPrivacy() === types_1.ApiTypes.v1.GroupPrivacyLevel.PRIVATE;
    };
    GroupWrapper.prototype.getLogoUrl = function () {
        try {
            return this.group.details.logoUrl;
        }
        catch (e) {
            return;
        }
    };
    GroupWrapper.prototype.getLogo = function () {
        try {
            return this.group.details.logo || this.getLogoFromUrl();
        }
        catch (e) {
            return this.getLogoFromUrl();
        }
    };
    GroupWrapper.prototype.getLogoPosition = function () {
        try {
            return this.group.details.logoPosition || {};
        }
        catch (e) {
            return {};
        }
    };
    GroupWrapper.prototype.getLogoFromUrl = function () {
        var url = this.getLogoUrl();
        if (!url) {
            return;
        }
        if (this.isDefaultCover(url)) {
            return tslib_1.__assign(tslib_1.__assign({}, this.getDefaultCoverDimensions(url)), { mediaId: url, isWixmpUrl: true });
        }
        var mediaId = stringUtils_1.parseImageName(url);
        var _a = stringUtils_1.parseWidthHeight(url), width = _a.width, height = _a.height;
        return { mediaId: mediaId, width: width, height: height };
    };
    GroupWrapper.prototype.getLogoDimensions = function () {
        var logoUrl = this.getLogoUrl();
        if (!logoUrl) {
            return;
        }
        if (this.isDefaultCover(logoUrl)) {
            var _a = this.getDefaultCoverDimensions(logoUrl), width = _a.width, height = _a.height;
            return { w: width, h: height };
        }
        var logo = this.getLogo();
        if (logo) {
            var width = logo.width, height = logo.height;
            return { w: width, h: height };
        }
    };
    GroupWrapper.prototype.getScaledLogo = function (targetWidth, targetHeight) {
        var logoUrl = this.getLogoUrl();
        var logo = this.getLogo();
        if (!logo && !logoUrl) {
            return;
        }
        var options = {};
        var image = { targetHeight: targetHeight, targetWidth: targetWidth, url: logoUrl };
        if (logoUrl && this.isDefaultCover(logoUrl)) {
            options.baseHostURL = WixStatics_1.WixStatics.toWixmpImageURL(logoUrl).origin + "/";
            var _a = this.getDefaultCoverDimensions(logoUrl), width = _a.width, height = _a.height;
            image.sourceWidth = width;
            image.sourceHeight = height;
        }
        else if (logo) {
            var width = logo.width, height = logo.height, mediaId = logo.mediaId;
            image.relativeUrl = mediaId;
            image.sourceWidth = width;
            image.sourceHeight = height;
        }
        try {
            var imageSDK = new ImageSDK_1.ImageSDK(image, options);
            return imageSDK.getScaledUrl();
        }
        catch (e) {
            console.log('Error in GroupWrapper.getScaledLogo');
            return logoUrl;
        }
    };
    GroupWrapper.prototype.getMembersName = function () {
        try {
            return this.group.details.membersName;
        }
        catch (e) { }
    };
    GroupWrapper.prototype.getMembersCount = function () {
        try {
            return this.group.memberCount || 0;
        }
        catch (e) {
            return 0;
        }
    };
    GroupWrapper.prototype.getPendingMembersCount = function () {
        try {
            return this.group.pendingMemberCount || 0;
        }
        catch (e) {
            return 0;
        }
    };
    GroupWrapper.prototype.getOwner = function () {
        try {
            return this.group.createdBy;
        }
        catch (e) {
            return Member_1.Anonymous;
        }
    };
    GroupWrapper.prototype.getMemberPermission = function () {
        try {
            return this.group.settings.permittedToInviteMembers;
        }
        catch (e) { }
    };
    GroupWrapper.prototype.getGroupUpdatesSettings = function () {
        var _a = this.group.settings, memberWelcomePostEnabled = _a.memberWelcomePostEnabled, groupDetailsChangedPostEnabled = _a.groupDetailsChangedPostEnabled, eventAddedPostEnabled = _a.eventAddedPostEnabled;
        return {
            memberWelcomePostEnabled: memberWelcomePostEnabled,
            groupDetailsChangedPostEnabled: groupDetailsChangedPostEnabled,
            eventAddedPostEnabled: eventAddedPostEnabled,
        };
    };
    GroupWrapper.prototype.setGroup = function (group) {
        var _a;
        this.group = group;
        this.accessRestriction = new GroupAccessRestriction_1.GroupAccessRestriction((_a = group.settings) === null || _a === void 0 ? void 0 : _a.accessRestriction);
    };
    GroupWrapper.prototype.isDefaultCover = function (src) {
        return WixStatics_1.WixStatics.isWixmpUrl(src);
    };
    GroupWrapper.prototype.getDefaultCoverDimensions = function (src) {
        // https://images-wixmp-fab9913bae2ffa83c48a0b95.wixmp.com/backlit-bonding-casual-708392.jpg
        return { width: 5090, height: 3393 };
    };
    GroupWrapper.prototype.getAccessRestriction = function () {
        return this.accessRestriction;
    };
    GroupWrapper.prototype.getGroup = function () {
        return this.group;
    };
    GroupWrapper.prototype.isAdmin = function () {
        try {
            var roles = this.group.roles;
            return MemberRole_1.hasAdminRole(roles);
        }
        catch (e) { }
        return false;
    };
    GroupWrapper.prototype.isJoined = function () {
        var relationship = this.group.relationship;
        return relationship === types_1.ApiTypes.v1.RelationshipWithGroup.JOINED;
    };
    return GroupWrapper;
}());
exports.GroupWrapper = GroupWrapper;
//# sourceMappingURL=GroupWrapper.js.map